import _ from 'lodash';
import invariant from 'invariant';

import vb from './definition';

import { unwrap } from './util';

vb.arrayMinLength = (length, message) => ({
	validator: v => _.isArray(v) && v.length >= length,
	message: message || 'не более ' + length + ' значений',
});

vb.arrayMaxLength = (length, message) => ({
	validator: v => _.isArray(v) && v.length <= length,
	message: message || 'не менее ' + length + ' значений',
});


vb.uniqueArrayBy = (propName, message) => ({
	validator: maybeUniqueArray => {
		const next = i => i + 1;
		const unwrapItemByPropName = item => unwrap(_.get(unwrap(item), propName));

		const compareEveryItem = comparer => (item1, index) => {
			const value1 = unwrapItemByPropName(item1);
			const tail = maybeUniqueArray.slice(next(index));

			return tail.some(item2 =>
				comparer(value1, unwrapItemByPropName(item2))
			);
		};

		invariant(_.isArray(maybeUniqueArray), '[vb.uniqueArrayBy] Value should be array');

		return !maybeUniqueArray.some(compareEveryItem((value1, value2) =>
			value1 === value2,
		));

	},
	message: message,
});
